// Update the ProductList component
import {AppContext} from "./../context/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router";
import Loading from "../sharedComponents/Loaders/Loading";
import {Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import ApiConfig from "../api/ApiConfig";
import {getWithAuthCallWithErrorResponse, simpleGetCall} from "../api/ApiServices";

function MachineOrders() {

    const {id} = useParams();
    const {sidebar, count} = useContext(AppContext);
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [vendingMachine, setVendingMachine] = useState({
        id: 0,
        name: "",
        MachineId: "",
        location: "",
        latitude: "",
        longitude: "",
        country: "",
        totalSlots: 10,
        totalRows: 0,
        totalColumn: 10,
        isDelete: false,
        deviceType: 1
    });

    const getVendingMachineEditData = () => {
        simpleGetCall(`${ApiConfig.GET_EDIT_DATA_BY_ID}?id=${id}`)
            .then((res) => {
                let data = res.vendingMachineLists[0];
                setVendingMachine({
                    id: data.id,
                    name: data.vendingMachineName,
                    MachineId: data.vendingMachineID,
                    location: data.vendingMachineLocation,
                    latitude: data.latitude,
                    longitude: data.longitude,
                    country: data.country,
                    totalSlots: data.totalSlots ? data.totalSlots : 0,
                    totalRows: data.totalRows ? data.totalRows : 0,
                    totalColumn: data?.totalColumn ? data.totalColumn : 0,
                    isDelete: false,
                    deviceType: data?.deviceType ? data.deviceType : 1
                });
                // }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getOrders = () => {
        setIsLoading(true);
        const currentDate = new Date();
        const month =  currentDate.getMonth() + 1;
        const year =  currentDate.getFullYear();
        let apiUrl = ApiConfig.ORDER_LIST + `${month}&Year=${year}`;
        if (id) {
            apiUrl += `&MachineId=${id}`;
        }
        getWithAuthCallWithErrorResponse(apiUrl)
            .then((res) => {
                let data = res.json;
                if (data) {
                    setOrders(data.data);
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };


    useEffect(() => {
        getOrders();
        getVendingMachineEditData()
    }, [id]);

    const shippingStatuses = [
        {value: 0, label: "N/A"},
        {value: 1, label: "Your Order is Being Packed for Shipping"},
        {value: 2, label: "Your Order Has Been Shipped"}
    ];

    const pickupStatuses = [
        {value: 0, label: "N/A"},
        {value: 1, label: "Order Ready for Pickup at Vending Machine"},
        {value: 2, label: "Order Released/Product Dispensed"}
    ];

    function renderStatusLabel(inputStatus, statuses) {
        const status = statuses.find(status => status.value === Number(inputStatus));
        return status ? status.label : "N/A";
    }

    return (<>
        <main id="cx-main" className={sidebar ? "dashboard-main" : "cx-active dashboard-main"}>
            <h5 className="text-center mb-3">{vendingMachine.MachineId ? 'Vending Machine: ' : 'Virtual Machine: '}{vendingMachine.name} {vendingMachine.MachineId ? `(${vendingMachine.MachineId})` : ''}</h5>
            <div className="table-wrapper">
                <div className="mb-3">
                    <Link to="/VendingMachine">
                        ← Back to Vending Machines
                    </Link>
                </div>
                <div className="headerFlex">
                    <div className="innerLabel">
                        <label className="labelTxt">
                            Total Records : {orders.length}
                        </label>
                    </div>
                </div>
                {isLoading ? (<Loading/>) : (<Table id="Order" class="table display">
                    <thead>
                    <tr>
                        <th>Sr No.</th>
                        <th>Order Number</th>
                        <th>Customer Name</th>
                        <th>Phone Number</th>
                        <th>Order Status</th>
                        <th>Price</th>
                        <th>Date & Time</th>
                        <th>Shipping Status</th>
                        <th>Pickup Status</th>
                        <th>Order Completed</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orders?.length > 0 && orders.map((order, index) => {
                        return (<tr key={"order" + index}>
                            <td>{index + 1}</td>
                            <td>{order?.orderId}</td>
                            <td>
                                {order?.customerName}
                            </td>
                            <td>{order?.phoneNumber ? order?.phoneNumber : "NULL"}</td>
                            <td>{order?.orderStatus ? order?.orderStatus : "NULL"}</td>
                            <td>{order?.price ? order?.price : "NULL"}</td>
                            <td>{order?.orderDate ? order?.orderDate : "NULL"}</td>
                            <td>{renderStatusLabel(order?.shippingStatus, shippingStatuses)}</td>
                            <td>{renderStatusLabel(order?.pickupStatus, pickupStatuses)}</td>
                            <td>{order?.orderCompleted ? "true" : "false"}</td>
                        </tr>);
                    })}
                    </tbody>
                </Table>)}
            </div>
        </main>
    </>);
}

export default MachineOrders;
